<!-- Sign In Bar-->
<div *ngIf="showSignInComponent && (isLoggedIn$ | async) === false">
  <ft-sign-in-bar
    [signInBarTextLabel]="'literature.signin-title' | translate"
    [isFullPageWidth]="true"
    [spacingBottom]="'none'"
  ></ft-sign-in-bar>
</div>
<!-- EDS Banner and filters -->
<div edsSpacing="lg" *ngIf="!isError">
  <ft-document-filters
    [page]="page"
    [pageType]="pageType"
    [component]="component"
    [isLoaded]="dataLoaded"
    [numberOfFliterData]="numberOfFliterData"
    [totalNumberOfData]="totalNumberOfData"
    (downloadExcel)="downloadExcel()"
  ></ft-document-filters>
</div>
<div *ngIf="isError">
  <eds-breadcrumbs
    [items]="showBreadcrumb ? breadcrumbItems : null"
    theme="basic"
    edsPadding
    edsPaddingLeft="sm"
  >
  </eds-breadcrumbs>
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol>
          <div edsPadding edsPaddingAll="lg">
            <div edsSpacing="lg">
              <eds-image
                imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
              >
              </eds-image>
            </div>
            <eds-title edsSpacing="sm" size="h3" theme="dark">
              {{ "literature.lit-error-message" | translate }}
            </eds-title>
            <ul
              class="list--unordered"
              edsList
              innerHTML="{{
                'literature.lit-listing-no-data-result-message-list' | translate
              }}"
            ></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  edsGrid
  edsSpacing="md"
  *ngIf="
    numberOfFliterData !== 0 &&
    !isInternational &&
    showClientToggle &&
    !isRegulatoryPage
  "
  class="literature-document-listing"
>
  <div
    edsPadding
    edsPaddingLeft="md"
    edsPaddingRight="md"
    edsFlexbox
    [flexDirection]="(isMobile$ | async) === true ? 'column' : 'row'"
    justifyContent="space-between"
  >
    <div
      edsFlexbox
      [flexDirection]="(isMobile$ | async) === true ? 'column' : 'row'"
      class="literature-document-listing__text-space"
      edsSpacing="sm"
    >
      <div>
        <p
          edsPadding
          [ngStyle]="{
            'padding-top': (isMobile$ | async) === true ? '' : '2px'
          }"
          edsPaddingRight="xs"
          edsPaddingLeft="xs"
        >
          {{ "literature.you-can-also" | translate }}
        </p>
      </div>
      <div edsFlexbox flexDirection="row">
        <eds-link-item
          [title]="'literature.view-orders' | translate"
          [href]="litOrderHistoryUrl"
          [isNewWindow]="false"
          edsPadding
          edsPaddingRight="sm"
        ></eds-link-item>
        <div
          class="separator"
          [ngClass]="
            (isMobile$ | async) === true
              ? ''
              : 'literature-document-listing__separator-height'
          "
        ></div>
        <eds-link-item
          [title]="'literature.email-preference' | translate"
          [href]="emailPrefrenceLink"
          [isNewWindow]="false"
          edsPadding
          edsPaddingLeft="sm"
          edsPaddingRight="sm"
        ></eds-link-item>
      </div>
    </div>
    <div>
      <div edsFlexbox flexDirection="row">
        <div class="literature-document-listing__text-space">
          <eds-title size="small-light">
            {{ "literature.client-use-only" | translate }}
          </eds-title>
        </div>
        <eds-switch
          [switchId]="'clientUseSwitch'"
          [disabled]="false"
          [label]="'literature.show-client-use-switch' | translate"
          [labelOff]="'literature.off' | translate"
          [labelOn]="'literature.on' | translate"
          (switchPressed)="filterOnClientUse($event)"
          ariaLabelledbyStr="clientUseSwitchLabel"
          labelId="clientUseSwitch"
        ></eds-switch>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="rowData?.length === 0 && !dataLoaded && !isError" edsGrid>

  <div edsRow edsSpacing="md" alignItems="center">

    <ngx-skeleton-loader
      edsCol
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>

    <ngx-skeleton-loader
      edsCol
      [columnNumbers]="{ s: 2, m: 2, l: 2 }"
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div edsRow>
    <ngx-skeleton-loader
      edsCol
      [count]="20"
      animation="pulse"
      [theme]="{
        'background-color': '#e8e8e8',
        'border-radius': '0',
        height: 'var(--space-xxl)'
      }"
    ></ngx-skeleton-loader>
  </div>
</div> -->
<!-- / end of skeleton loader -->
<ng-container
  *ngIf="
    pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS &&
    isShareclassLevelRegulatory
  "
>
  <div edsGrid class="literature-document-listing">
    <div edsRow>
      <div edsCol edsPadding edsPaddingLeft="xs" *ngIf="dataLoaded">
        {{ "literature.view-the-proxy" | translate }}
        <eds-proximal
          class="literature-document-listing__proxy-voting-link"
          placement="RegulatoryFundDocumentTop"
        ></eds-proximal>
      </div>
    </div>
  </div>
</ng-container>
<div id="literatureScrollPosition"></div>
<ng-container *ngIf="numberOfFliterData === 0 && dataLoaded">
  <div edsGrid>
    <div class="container">
      <div edsRow>
        <div edsCol>
          <div edsPadding edsPaddingAll="lg">
            <div edsSpacing="lg">
              <eds-image
                imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
              >
              </eds-image>
            </div>
            <eds-title edsSpacing="sm" size="h3" theme="dark">
              {{
                "literature.lit-listing-no-search-result-message-start"
                  | translate
              }}
              {{ searchKey }}
              {{
                "literature.lit-listing-no-search-result-message-end"
                  | translate
              }}
            </eds-title>
            <eds-title edsSpacing="sm" size="h6" theme="dark">
              {{
                "literature.lit-listing-no-search-result-message-suggestion"
                  | translate
              }}
            </eds-title>
            <ul
              class="list--unordered"
              edsList
              innerHTML="{{
                'literature.lit-listing-no-search-result-message-list'
                  | translate
              }}"
            ></ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="numberOfFliterData !== 0 && !isHandheld">
  <div edsGrid>
    <div *ngIf="!isRegulatoryPage" edsRow>
      <eds-proximal edsCol placement="LiteratureListingTop"></eds-proximal>
    </div>
    <div *ngIf="isRequeryResult" edsRow>
      <eds-title edsCol edsSpacing="sm" size="h6" theme="dark">
        {{ "literature.lit-results-returned-with-no-filters-set" | translate }}
      </eds-title>
    </div>
    <div edsRow *ngIf="!isRegulatoryPage">
      <div edsCol edsSpacing="sm">
        <ag-grid-angular
          stickyHeader
          #literatureDocumentGrid
          style="width: 100%; height: 100%"
          class="ag-theme-frk"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [frameworkComponents]="frameworkComponents"
          [rowSelection]="'multiple'"
          [paginationPageSize]="paginationPageSize"
          [suppressPaginationPanel]="true"
          [suppressHorizontalScroll]="true"
          [suppressRowClickSelection]="true"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
          [context]="gridContext"
          [pagination]="true"
          [rowHeight]="rowHeight"
          domLayout="autoHeight"
          [suppressRowHoverHighlight]="true"
          [suppressCellSelection]="false"
          [ensureDomOrder]="true"
          (gridReady)="onGridReady($event)"
          [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</ng-container>
<div edsGrid>
  <div
    edsRow
    *ngIf="
      customRowData?.length > 0 &&
      !isHandheld &&
      pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS
    "
  >
    <div
      edsCol
      edsPadding
      edsPaddingLeft="xs"
      edsPaddingRight="xs"
      edsSpacing="md"
    >
      <!-- eds Dynamic table -->
      <eds-dynamic-table
        [colDefs]="columnDefs"
        [rowData]="customRowData"
        tableTheme="secondary"
        [hasBorders]="true"
        [rowTemplate]="regulatoryFundTemplate"
        [mobileTemplate]="regulatoryFundTemplate"
        [showPagination]="false"
        [labelNoMatchingData]="
          'products.portfolio-holdings-no-filter-data-message' | translate
        "
        idCol="fundShareClassId"
        [sortAccessibilityText]="'common.sortAccessibilityText' | translate"
        [ariaLabelGoToPage]="'common.ariaLabelGoToPage' | translate"
        [ariaLabelPagination]="'common.navigationLandmark' | translate"
        [sortAriaLiveText]="'common.sortAriaLiveText' | translate"
        [pageTransitionAriaLiveText]="
          'common.pageTransitionAriaLiveText' | translate
        "
        [hasStickyHeader]="true"
      ></eds-dynamic-table>
      <!-- Desktop Template -->
      <ng-template #regulatoryFundTemplate let-item>
        <tr class="dynamic-table__tr dynamic-table__tr--has-borders">
          <td>
            <ft-regulatory-fund-name-cell-renderer
              [cellRendererData]="{ data: item }"
            ></ft-regulatory-fund-name-cell-renderer>
          </td>
          <td
            *ngFor="let document of documentsWithPreview"
            class="dynamic-table__td"
          >
            <ft-icon-column
              [cellRendererData]="{
                data: item,
                colDef: { colId: document },
                isSiteIntl: isInternational,
                isPreviewLink: true
              }"
            ></ft-icon-column>
          </td>
        </tr>
      </ng-template>
    </div>
  </div>
</div>
<!-- Mobile view -->
<ng-container *ngIf="numberOfFliterData !== 0 && isHandheld">
  <!-- Showing X of Y -->
  <div edsGrid>
    <div edsRow *ngIf="!isRegulatoryPage">
      <div edsCol edsSpacing="md" [columnNumbers]="{ s: 4, m: 4, l: 2 }">
        <eds-dropdown
          *ngIf="isHandheld"
          ariaLabel="Dropdown"
          [dropdownId]="'id1'"
          [name]="'name1'"
          [items]="sortByItems"
          [label]="sortByDropDownLabel"
          [preselectedValue]="sortByItems[0]"
          (dropdownChange)="onSorting(rowData, $event)"
        ></eds-dropdown>
      </div>
    </div>
    <div edsRow *ngIf="!isRegulatoryPage">
      <eds-proximal edsCol placement="LiteratureListingTop"></eds-proximal>
    </div>
    <ft-literature-document-card-container
      *ngIf="pageType !== LiteraturePageType.REGULATORY_FUND_DOCUMENTS_GLOBAL"
      [rowData]="
        pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS
          ? customRowData
          : currentPage
      "
      [columnDefs]="columnDefs"
      [isCustom]="pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS"
      (selectionEmitter)="onSelectionChanged($event, href)"
      edsRow
    ></ft-literature-document-card-container>
  </div>
</ng-container>
<div edsGrid *ngIf="!isRegulatoryPage">
  <div edsRow>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 4, l: 9 }"
      [edsSpacing]="(isMobile$ | async) === true ? 'md' : 'none'"
      edsFlexbox
      [justifyContent]="'left'"
    >
      <eds-pagination
        *ngIf="numberOfPages > 0"
        [pages]="numberOfPages"
        [activePage]="activePage"
        [pageTitle]="pageTitle"
        (pageChanged)="onPageChanged($event)"
        prevPageText="{{ 'literature.previous' | translate }}"
        nextPageText="{{ 'literature.next' | translate }}"
        ariaLabelGoToPage="{{ 'literature.ariaLabelGoToPage' | translate }}"
        [ariaLabelPageNav]="'common.navigationLandmark' | translate"
      >
      </eds-pagination>
    </div>
    <div
      edsCol
      [columnNumbers]="{ s: 4, m: 4, l: 3 }"
      edsFlexbox
      justifyContent="right"
    >
      <div edsCol [columnNumbers]="{ s: 4, m: 7, l: 12 }">
        <eds-dropdown
          ariaLabel="Dropdown"
          [dropdownId]="'itemsPerPageBottomDropdown'"
          [name]="'itemsPerPageBottomDropdown'"
          *ngIf="numberOfFliterData !== 0"
          [items]="rowNoItems"
          [label]="rowsNoDropDownLabel"
          [preselectedValue]="pageSize"
          (dropdownChange)="onChange($event)"
        >
        </eds-dropdown>
      </div>
    </div>
    <!-- / Dropdown -->
  </div>
</div>
<ng-container
  *ngIf="pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS_GLOBAL"
>
  <ft-literature-global-regulatory-listing
    [stateData]="globalRegulatoryRowData"
    [colDefs]="columnDefs"
  ></ft-literature-global-regulatory-listing>
</ng-container>
<ng-container *ngIf="pageType === LiteraturePageType.REGULATORY_FUND_DOCUMENTS">
  <eds-proximal placement="RegulatoryFundDocumentBottom"></eds-proximal>
</ng-container>
<div edsGrid>
  <div edsRow>
    <ft-literature-dialog
      [dialogId]="ModalIdValue"
      [modalIdEnum]="ModalId['Sticky_Modal']"
      [multiSelectDialogData]="multiSelectDialogData"
      [confirmSelectionCount]="confirmSelectionNodes?.length"
      (dialog)="closeDialog($event)"
      (deleteDoc)="deselectedDownloadDocs($event)"
      (downloadStart)="startDownload()"
      (emailStart)="startEmail()"
      (modalClose)="closeModal(ModalId['Sticky_Modal'])"
      (backEmail)="emailBack()"
      (continueEmail)="emailContinue($event)"
      (deleteCartDoc)="updateStorage($event)"
      [gridData]="dialogData"
      (selectAll)="selectAllPopupAction($event)"
      (modalClosedInternally)="modalClosedInternally($event)"
      (emptyCart)="emptyCart($event)"
    ></ft-literature-dialog>
  </div>
</div>
<eds-sticky-footer
  [itemCount]="rowCountValue"
  [isHide]="rowCount === 0"
  variation="2"
  [primaryAction]="emailStickyButton"
  [secondaryAction]="downloadStickyButton"
  [tertiaryAction]="addToCartStickyButton"
  (btnSubscribePrimary)="operationToPerform('email')"
  (btnSubscribeSecond)="operationToPerform('download')"
  (btnSubscribeThird)="operationToPerform('addToCart')"
  [stickyFooterName]="'document_listing_sticky_footer'"
></eds-sticky-footer>
